import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import { Pagination } from 'antd';
import style from './PaginationComponent.module.scss';

export const PaginationComponent: React.FC = () => {
	const { changeCurrentPage, dishesForAssign, currentPage, countOfItems } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const from = (currentPage - 1) * Number(countOfItems) + 1;
	const to = currentPage * Number(countOfItems);
	const total = dishesForAssign.dishesCount;

	return (
		<div className={style.container} data-test="PaginationComponent">
			<Text
				className={style.counter}
				translationNameSpace="listing"
				translationKey="paginationLabel"
				translationOptions={{
					from,
					to: to < total ? to : total,
					total,
				}}
				size="xs"
			/>
			<Pagination
				current={currentPage}
				pageSize={Number(countOfItems)}
				total={dishesForAssign.dishesCount}
				onChange={changeCurrentPage}
				showSizeChanger={false}
			/>
			<div className={style.plug}></div>
		</div>
	);
};
